import { useDispatch } from 'react-redux';
import { useSearchParams } from 'react-router-dom';
import { setToken } from '../../features/redux/sessionSlice';

function LoggedInPage() {
  let [searchParams] = useSearchParams();
  const token = searchParams.get('token');
  console.log(token);
  const dispatch = useDispatch();
  dispatch(setToken(token));
}

export default LoggedInPage;
